export const LOAD_POLICIES_LIST = 'LOAD_POLICIES_LIST'
export const LOAD_POLICIES_LIST_FULFILLED = 'LOAD_POLICIES_LIST_FULFILLED'
export const LOAD_POLICIES_LIST_PENDING = 'LOAD_POLICIES_LIST_PENDING'
export const LOAD_POLICIES_LIST_REJECTED = 'LOAD_POLICIES_LIST_REJECTED'

export const GET_POLICIES_DETAILS = 'GET_POLICIES_DETAILS'
export const GET_POLICIES_DETAILS_FULFILLED = 'GET_POLICIES_DETAILS_FULFILLED'
export const GET_POLICIES_DETAILS_PENDING = 'GET_POLICIES_DETAILS_PENDING'
export const GET_POLICIES_DETAILS_REJECTED = 'GET_POLICIES_DETAILS_REJECTED'

// update policies

export const UPDATE_POLICIES_DETAILS = 'UPDATE_POLICIES_DETAILS'
export const UPDATE_POLICIES_DETAILS_FULFILLED = 'UPDATE_POLICIES_DETAILS_FULFILLED'
export const UPDATE_POLICIES_DETAILS_PENDING = 'UPDATE_POLICIES_DETAILS_PENDING'
export const UPDATE_POLICIES_DETAILS_REJECTED = 'UPDATE_POLICIES_DETAILS_REJECTED'

// ACTIVATE policies

export const ACTIVATE_POLICIES_DETAILS = 'ACTIVATE_POLICIES_DETAILS'
export const ACTIVATE_POLICIES_DETAILS_FULFILLED = 'ACTIVATE_POLICIES_DETAILS_FULFILLED'
export const ACTIVATE_POLICIES_DETAILS_PENDING = 'ACTIVATE_POLICIES_DETAILS_PENDING'
export const ACTIVATE_POLICIES_DETAILS_REJECTED = 'ACTIVATE_POLICIES_DETAILS_REJECTED'

// DEACTIVATE policies

export const DEACTIVATE_POLICIES_DETAILS = 'DEACTIVATE_POLICIES_DETAILS'
export const DEACTIVATE_POLICIES_DETAILS_FULFILLED = 'DEACTIVATE_POLICIES_DETAILS_FULFILLED'
export const DEACTIVATE_POLICIES_DETAILS_PENDING = 'DEACTIVATE_POLICIES_DETAILS_PENDING'
export const DEACTIVATE_POLICIES_DETAILS_REJECTED = 'DEACTIVATE_POLICIES_DETAILS_REJECTED'

// CREATE POLICIES

export const CREATE_POLICIES_DETAILS = 'CREATE_POLICIES_DETAILS'
export const CREATE_POLICIES_DETAILS_FULFILLED = 'CREATE_POLICIES_DETAILS_FULFILLED'
export const CREATE_POLICIES_DETAILS_PENDING = 'CREATE_POLICIES_DETAILS_PENDING'
export const CREATE_POLICIES_DETAILS_REJECTED = 'CREATE_POLICIES_DETAILS_REJECTED'

// DELETE POLICIES

export const DELETE_POLICIES_DETAILS = 'DELETE_POLICIES_DETAILS'
export const DELETE_POLICIES_DETAILS_FULFILLED = 'DELETE_POLICIES_DETAILS_FULFILLED'
export const DELETE_POLICIES_DETAILS_PENDING = 'DELETE_POLICIES_DETAILS_PENDING'
export const DELETE_POLICIES_DETAILS_REJECTED = 'DELETE_POLICIES_DETAILS_REJECTED'

// Get Destinations

export const GET_DESTINATIONS = 'GET_DESTINATIONS'
export const GET_DESTINATIONS_FULFILLED = 'GET_DESTINATIONS_FULFILLED'
export const GET_DESTINATIONS_PENDING = 'GET_DESTINATIONS_PENDING'
export const GET_DESTINATIONS_REJECTED = 'GET_DESTINATIONS_REJECTED'
